import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tagQuery: '',
    members: [
      {
        name: 'Maria Manchego',
        title: '👑 Formand',
        photo: 'maria_small.jpg',
      },
      {
        name: 'Lotte Leerdammer',
        title: '🥈 Næstformand',
        photo: 'lotte_small.jpg',
      },
      {
        name: 'Anna Camembert',
        photo: 'anna_small.jpg',
      },
      {
        name: 'Emil Habanero',
        photo: 'emil_small.jpg',
      },
      {
        name: 'Michael Butterkäse',
        photo: 'michael_small.jpg',
        title: '👨‍💻 Webmaster',
      },
      {
        name: 'Kristine Pecorino',
        photo: 'krissy_small.jpg',
      },
    ],
    events: [
      {
        date: '2017-05-26',
        hosts: 'Kristine og Emil',
        participants: [
          'Kristine', 'Emil', 'Maria', 'Michael', 'Anna', 'Charlotte',
        ]
      },
      {
        date: '2017-09-30',
        hosts: 'Maria og Michael',
        participants: [
          'Kristine', 'Emil', 'Maria', 'Michael', 'Anna', 'Charlotte',
        ]
      },
      {
        date: '2018-04-28',
        hosts: 'Maria og Michael',
        participants: [
          'Kristine', 'Emil', 'Maria', 'Michael', 'Anna', 'Charlotte',
        ]
      },
      {
        date: '2018-09-22',
        hosts: 'Anna',
        participants: [
          'Kristine', 'Maria', 'Michael', 'Anna', 'Charlotte',
        ]
      },
      {
        date: '2019-05-04',
        hosts: 'Charlotte',
        participants: [
          'Kristine', 'Emil', 'Maria', 'Michael', 'Anna', 'Julius', 'Charlotte',
        ]
      },
      {
        date: '2020-02-22',
        hosts: 'Kristine og Emil',
        participants: [
          'Kristine', 'Emil', 'Michael', 'Maria', 'Anna', 'Charlotte', 'Claus', 'Jon', 'Maiken',
        ]
      },
    ],
    cheese: [
      {
        id: 1,
        name: 'Saint Agur',
        origin: 'Auvergne, Frankrig',
        image: 'saint-agur.jpg',
        description: 'Fedtprocent på 60, lagret i 60 dage. Først produceret i 1988.',
        tags: ['blåskimmel', 'komælk'],
        ratings: {
          'Maria': 4.5,
          'Michael': 5,
        },
      },
      {
        id: 2,
        name: 'Mothais a la Feuille',
        origin: 'Poitou-Charentes, Frankrig',
        image: 'mothais-a-la-feuille.jpg',
        description: 'Fransk AOC-ost lavet på upasteuriseret gedemælk. Bliver modnet i meget høj luftfugtighed pakket ind i blade hvilket gør at osten har et højt fugtindhold for dens størrelse.',
        tags: ['gedemælk'],
        ratings: {
          'Michael': 5,
        },
        date: ['2018-04-28'],
      },
      {
        id: 3,
        name: 'Habanero Cheddar',
        origin: 'Tistrup Mejeri, Danmark',
        image: 'habanero-cheddar.jpg',
        description: 'Sælges af Arla Unika. Ideen er at osten dæmper chiliens styrke hvilket gør det muligt at smage flere nuancer i chilien. Lagret ca. 1 år.',
        tags: ['komælk'],
        ratings: {
          'Michael': 3,
        },
        date: ['2018-04-28'],
      },
      {
        id: 4,
        name: 'Høgelundgaard',
        origin: 'Sønderjylland, Danmark',
        image: 'hoegelundgaard.jpg',
        description: 'Fremstillet på Høgelund Mejeri. Sælges af Arla Unika. Har usædvanligt mange skimmelkulturer og er tilsat gær. Det er med til at give osten sin helt særlige, frugtagtige duft og smag.',
        tags: ['komælk', 'blåskimmel'],
        ratings: {
          'Michael': 5,
        },
        date: ['2018-04-28'],
      },
      {
        id: 5,
        name: 'Rød Krystal',
        origin: 'Them Ost, Danmark',
        image: 'roed-krystal.png',
        description: 'En fast, moden og aromatisk ost uden at være stærk. Smagen er med noter af salt, umami og mere sødme en parmasan. Under lagringen fremkommer knasende sprøde proteinkrystaller der perler frisk på tungen.',
        tags: ['komælk'],
        ratings: {
          'Michael': 4,
        },
        date: ['2018-04-28'],
      },
      {
        id: 6,
        name: 'Polderkaas Brun',
        origin: 'Holland',
        image: 'polderkaas-sheep-young.jpg',
        description: 'Mild fåreost',
        tags: ['fåremælk'],
        ratings: {
          'Michael': 4,
        },
        date: ['2018-04-28'],
      },
      {
        id: 7,
        name: 'Polderkaas Blanc',
        origin: 'Holland',
        image: 'polderkaas-goat.jpg',
        description: '',
        tags: ['gedemælk'],
        ratings: {
          'Michael': 4.5,
        },
        date: ['2018-04-28'],
      },
      {
        id: 8,
        name: 'Danablu',
        origin: 'Danmark',
        image: 'danablu.jpg',
        description: 'En dansk mærkevare og en af de få danske BGB-oste (Beskyttet Geografisk Betegnelse). Lagres i 5-6 uger.',
        tags: ['komælk', 'blåskimmel', 'semi-blød'],
        ratings: {
          'Michael': 5,
        },
        date: ['2018-04-28', '2020-02-22'],
      },
      {
        id: 9,
        name: 'Port Salut',
        origin: 'Pays de la Loire, Frankrig',
        image: 'port-salut.jpg',
        description: 'Halvfast rødkitost med en mild, noget syrlig smag.',
        tags: ['komælk', 'rødkit'],
        ratings: {
        },
        date: ['2018-04-28'],
      },
      {
        id: 10,
        name: 'Bastiaansen Blauw',
        origin: 'Holland',
        image: 'bastiaansen-blauw.jpg',
        description: 'Gede gouda med blåskimmel. Minimum lagret 5 måneder. 60+',
        tags: ['gedemælk', 'blåskimmel'],
        ratings: {
          'Michael': 4.5,
          'Maria': 4.5
        },
        date: ['2018-09-22'],
      },
      {
        id: 11,
        name: 'Fyrmester',
        origin: 'Thise Mejeri, Danmark',
        image: 'fyrmester.jpg',
        description: 'Lagres i mindst 14 måneder i den saltholdige havluft fra Vesterhavet. 48+',
        tags: ['komælk', 'fast'],
        ratings: {
          'Michael': 5,
          'Emil': 5,
          'Maria': 5,
          'Charlotte': 4,
          'Anna': 5,
          'Kristine': 4,
          'Julius': 4,
        },
        date: ['2018-09-22', '2019-05-04'],
      },
      {
        id: 12,
        name: 'Gederulle',
        origin: 'Santa Gadea, Spanien',
        image: 'santa-gadea.jpg',
        description: '55+',
        tags: ['gedemælk'],
        ratings: {
          'Michael': 5
        },
        date: ['2018-09-22'],
      },
      {
        id: 13,
        name: 'Høost',
        origin: 'Danmark',
        image: 'hoeost.jpg',
        description: '',
        tags: ['komælk'],
        ratings: {
          'Michael': 5,
          'Maria': 4
        },
        date: ['2018-09-22'],
      },
      {
        id: 14,
        name: 'Potkäse',
        origin: 'Hjemmelavet',
        image: 'potkase.jpg',
        description: 'Osterester modnet med rom.',
        tags: ['hjemmelavet'],
        ratings: {
          'Michael': 4
        },
        date: ['2018-09-22'],
      },
      {
        id: 15,
        name: 'Røget Fyrmester',
        origin: 'Danmark',
        image: 'fyrmester.jpg',
        description: '',
        tags: ['komælk'],
        ratings: {
          'Michael': 3.5,
          'Maria': 4
        },
        date: ['2018-09-22'],
      },
      {
        id: 16,
        name: 'Kovending',
        image: 'kovending.jpg',
        origin: 'Gjesing Mejeri, Danmark',
        description: 'Cremet hvidskimmel vasket med blåskimmelkultur. Sælges af Arla Unika. Cremoso. 70+',
        tags: ['komælk', 'hvidskimmel', 'blåskimmel', 'blød'],
        ratings: {
          'Maria': 5,
          'Anna': 5,
          'Charlotte': 3,
          'Emil': 5,
          'Michael': 5,
          'Kristine': 5,
        },
        date: ['2019-05-04'],
      },
      {
        id: 17,
        name: 'Cremeux de Bourgogne',
        image: 'cremeux-bourgogne.jpg',
        origin: 'Bourgogne, Frankrig',
        description: 'A triple crème cow’s milk cheese with a bloomy rind, lush and buttery taste full of milky and sweet flavors, with a marked lactic finish. Like all triple cream cheese, it has 75% butterfat content.',
        tags: ['komælk'],
        ratings: {
          'Maria': 4,
          'Anna': 4,
          'Julius': 3.5,
          'Charlotte': 2,
          'Emil': 3,
          'Michael': 3.5,
          'Kristine': 4,
        },
        date: ['2019-05-04'],
      },
      {
        id: 18,
        name: 'Gorgonzola Dolce',
        image: 'gorgonzola.jpg',
        origin: 'Castagna, Italien',
        description: '',
        tags: ['komælk', 'blåskimmel', 'blød'],
        ratings: {
          'Maria': 5,
          'Anna': 4,
          'Julius': 3,
          'Charlotte': 4,
          'Emil': 5,
          'Michael': 4.5,
          'Kristine': 5,
        },
        date: ['2019-05-04'],
      },
      {
        id: 19,
        name: 'Sweet Ulvedal',
        image: 'sweet-ulvedal.jpg',
        origin: 'Holland',
        description: 'Fast og flot med fin fuldfed og letmodnet smag – smager nærmest nøddeagtig og så med skønne små saltnister. Modnes i ca 40 uger. 48+',
        tags: ['komælk', 'fast'],
        ratings: {
          'Anna': 4,
          'Julius': 4,
          'Charlotte': 4,
          'Michael': 4,
          'Kristine': 3,
        },
        date: ['2019-05-04'],
      },
      {
        id: 20,
        name: 'Vesterhavsost Ekstra Modnet',
        origin: 'Thise Mejeri, Danmark',
        image: 'vesterhavsost-ekstra-modnet.jpg',
        description: 'Ostemesteren udvælger de ypperste Vesterhavsoste og sørger for at de lagres minimum et år, hvor vores klassiske Vesterhavsost er lagret ca. 6 måneder. Efter et år er osten mere fast, har endnu mere smagsfylde – endnu mere Vesterhav. Ostene lagres naturligvis ved Bovbjerg Fyr, hvor det frådende Vesterhav er nærmeste nabo. 48+',
        tags: ['komælk', 'fast'],
        ratings: {
          'Anna': 4.5,
          'Julius': 4,
          'Charlotte': 5,
          'Michael': 4.5,
          'Kristine': 3,
        },
        date: ['2019-05-04'],
      },
      {
        id: 21,
        name: 'Stilton',
        origin: 'England',
        image: 'stilton.jpg',
        description: '',
        tags: ['komælk', 'blåskimmel'],
        ratings: {
          'Anna': 3,
          'Julius': 3.5,
          'Charlotte': 5,
          'Michael': 3.5,
          'Kristine': 3,
        },
        date: ['2019-05-04'],
      },
      {
        id: 22,
        name: 'Président Brie Intense',
        origin: 'Vosges, Frankrig',
        image: 'president-brie-intense.jpg',
        description: '',
        tags: ['komælk', 'hvidskimmel'],
        ratings: {
          'Anna': 3,
          'Julius': 3.5,
          'Charlotte': 3,
          'Michael': 4,
          'Kristine': 4,
        },
        date: ['2019-05-04'],
      },
      {
        id: 23,
        name: 'Brie med trøffel-flødeost',
        image: 'kunigunde-troffelbrie.jpg',
        origin: 'Kunigunde, Danmark/Frankrig',
        description: 'Fransk brie toppet med flødeostecreme med 1,5% sommertrøffel.',
        tags: ['komælk'],
        ratings: {
          'Charlotte': 4,
          'Anna': 3.5,
          'Julius': 3.5,
          'Michael': 3.5,
          'Kristine': 3,
          'Emil': 5,
          'Maria': 4,
        },
        date: ['2019-05-04', '2020-02-22'],
      },
      {
        id: 24,
        name: 'Comté',
        origin: 'Frankrig',
        image: 'comte.jpg',
        description: '',
        tags: ['komælk', 'semi-fast'],
        ratings: {
          'Charlotte': 4,
          'Anna': 4,
          'Julius': 4,
        },
        date: ['2019-05-04'],
      },
      {
        id: 25,
        name: 'Chilibrie',
        description: '',
        tags: ['komælk'],
        ratings: {
          'Charlotte': 3,
          'Julius': 4,
          'Emil': 3.5,
          'Maria': 3.5,
        },
        date: ['2019-05-04'],
      },
      {
        id: 26,
        name: 'Prima Donna Rød (maturo)',
        origin: 'Holland',
        image: 'prima-donna-maturo.jpg',
        description: '',
        ratings: {
          'Charlotte': 4,
          'Julius': 3,
          'Maria': 4.5,
          'Michael': 4.5,
          'Anna': 4.5,
        },
        tags: ['komælk', 'fast'],
        date: ['2019-05-04'],
      },
      {
        id: 27,
        name: 'Peberfrugt ost',
        image: 'peberfrugtost.jpg',
        description: 'Smag af peberfrugt med et hint af chili.',
        ratings: {
          'Charlotte': 4.5,
          'Julius': 3,
          'Maria': 3,
          'Michael': 3.5,
          'Anna': 3.5,
          'Kristine': 2,
        },
        date: ['2019-05-04'],
      },
      {
        id: 28,
        name: 'Shropshire Blue',
        image: 'shropshire-blue.jpg',
        origin: 'Leicestershire, England',
        description: '',
        ratings: {},
        tags: ['komælk', 'blåskimmel', 'semi-blød'],
        date: ['2020-02-22'],
      },
      {
        id: 29,
        name: 'Gammel Knas',
        image: 'gammel-knas.jpg',
        origin: 'Danmark',
        description: 'Sælges af Arla Unika.',
        ratings: {},
        tags: ['komælk', 'fast'],
        date: ['2020-02-22'],
      },
      {
        id: 30,
        name: 'Époisses de Bourgogne',
        image: 'epoisses.jpg',
        origin: 'Époisses, Frankrig',
        description: 'Cremoso.',
        ratings: {},
        tags: ['komælk', 'blød', 'rødkit'],
        date: ['2020-02-22'],
      },
      {
        id: 31,
        name: 'Smokey Redwood Cheddar',
        image: 'smokey-redwood.jpg',
        origin: 'England',
        description: 'Fin røget smag. Blød konsistens.',
        ratings: {},
        tags: ['komælk', 'semi-blød'],
        date: ['2020-02-22'],
      },
      {
        id: 32,
        name: 'Potkäse med dild',
        image: 'dild-potkase.jpg',
        origin: 'Danmark',
        description: '',
        ratings: {},
        tags: ['blød'],
        date: ['2020-02-22'],
      },
      {
        id: 33,
        name: 'Fåreost med rosmarin',
        image: 'rosmarin.jpg',
        // origin: 'Danmark',
        description: '',
        ratings: {},
        tags: ['fåremælk', 'semi-fast'],
        date: ['2020-02-22'],
      },
      {
        id: 34,
        name: 'Borgonzola',
        image: 'borgonzola.jpg',
        origin: 'Bornholm, Danmark',
        description: '',
        ratings: {},
        tags: ['komælk', 'blåskimmel', 'semi-blød'],
        date: ['2020-02-22'],
      },
      {
        id: 35,
        name: 'Røget brie',
        image: 'roeget-brie.jpg',
        // origin: 'Bornholm, Danmark',
        description: '',
        ratings: {},
        tags: ['komælk', 'blød'],
        date: ['2020-02-22'],
      },
    ],
    wine: [
    ],
  },
  getters: {
    tags(state) {
      let tags = {}
      state.cheese.map(i => i.tags)
        .filter(tags => !!tags)
        .reduce((acc, tags) => acc.concat(tags), [])
        .forEach(t => { tags[t] = 1 })
      return Object.keys(tags)
    },
    cheeses(state) {
      let copy = state.cheese.slice(0)
      copy.sort((a, b) => {
        const aDate = (a.date && a.date[a.date.length - 1]) || '0000-00-00'
        const bDate = (b.date && b.date[b.date.length - 1]) || '0000-00-00'
        if (aDate > bDate) {
          return -1
        } else if (aDate < bDate) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        } else if (a.name > b.name) {
          return 1
        } else {
          return 0
        }
      })
      if (state.tagQuery) {
        copy = copy.filter(i => i.tags && i.tags.findIndex(t => t === state.tagQuery) !== -1)
      }
      return copy
    }
  },
  mutations: {
    updateCheese(state, { newInfo }) {
      state.cheese.splice(
        state.cheese.findIndex(i => i.id === newInfo.id),
        1, newInfo)
    },
    updateTagQuery(state, query) {
      state.tagQuery = query
    },
  }
})



// WEBPACK FOOTER //
// ./src/store.js